/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseCommandResult } from '../../models/base-command-result';
import { UpdateKpiCommand } from '../../models/update-kpi-command';

export interface ApiKpIsUpdateKpiPut$Params {
      body?: UpdateKpiCommand
}

export function apiKpIsUpdateKpiPut(http: HttpClient, rootUrl: string, params?: ApiKpIsUpdateKpiPut$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpIsUpdateKpiPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseCommandResult>;
    })
  );
}

apiKpIsUpdateKpiPut.PATH = '/api/KPIs/UpdateKpi';
